import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './CTAButton';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function Offer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(29 * 60);
  return <section id="offerta" className="scroll-mt-4 px-4 py-8" data-id="element-94" data-mp="1hopdlfkifebn">
      <div className="mx-auto max-w-2xl" data-id="element-95" data-mp="1hqippadw6qr1">
        <p className="text-center font-display text-[11px] font-bold uppercase tracking-[0.14em] text-terracotta sm:text-xs" data-id="element-96" data-mp="tybn3thkpnj6">
          Offerta speciale — Sistema completo 6-in-1
        </p>
        <h2 className="mt-1.5 text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-97" data-mp="13wrgy47zjawd">
          Accedi subito al sistema completo
        </h2>
        <p className="mt-2 text-center text-[15px] leading-snug text-graphite sm:text-base" data-id="element-98" data-mp="z00w73l8jr4m">
          Accedi subito al sistema completo e semplifica il modo in cui organizzi e prepari il tuo
          lavoro.
        </p>

        <div className="mt-4 rounded-2xl border-2 border-petrol bg-white p-4 sm:p-6" data-id="element-99" data-mp="pkh6pbiggwg7">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-100" data-mp="ujbny90rycy7">
            <img src={PRODUCT_IMG} alt="LOGOPEDIA PRO™ sistema completo 6-in-1 con 5 bonus" className="mx-auto w-full max-w-sm transition-transform duration-200 ease-out hover:scale-[1.01]" data-id="element-101" data-mp="ul4xbw2rvb9w" />
          </a>

          <h3 className="mt-2 text-center font-display text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-102" data-mp="6v0qlfuaeveo">
            🗣️ LOGOPEDIA PRO™ — Sistema Professionale Completo 6-in-1 per Logopedisti
          </h3>

          <p className="mt-3 text-center text-sm text-graphite" data-id="element-103" data-mp="ft4c4c59vs6h">
            Prezzo di Listino: <span className="line-through" data-id="element-104" data-mp="kmp2pj4jdjvn">97€</span>
          </p>
          <p className="mx-auto mt-1.5 w-fit rounded-lg bg-mustard px-3 py-1 text-center font-display text-[12px] font-extrabold uppercase leading-tight text-petrol sm:text-sm" data-id="element-105" data-mp="3k9fb856zrapg">
            🔥 72% di sconto — Offerta di lancio a tempo limitato
          </p>
          <p className="mt-2 text-center font-display text-4xl font-black leading-none text-petrol sm:text-5xl" data-id="element-106" data-mp="vde5cx7gho1y">
            Oggi Solo: 27€
          </p>
          <p className="mt-1 text-center text-xs text-graphite/80" data-id="element-107" data-mp="154il3z4yhcxu">
            Pagamento sicuro nella tua valuta.
          </p>

          <div className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-cream-dark px-3 py-2" data-id="element-108" data-mp="1078w2klhb3aj">
            <span className="text-[13px] font-semibold text-graphite" data-id="element-109" data-mp="ciz6d7l59ve4">
              ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
            </span>
            <span className="font-display text-base font-extrabold tabular-nums text-terracotta" data-id="element-110" data-mp="licffz5cwhyb">
              {hours}:{minutes}:{seconds}
            </span>
          </div>

          <CTAButton href={CHECKOUT_URL} className="mt-3" data-id="element-111" data-mp="1wvygoiohqa07" />
          <TrustLine className="mt-3" data-id="element-112" data-mp="1wykmacrtmffs" />
        </div>
      </div>
    </section>;
}